module.exports = __webpack_public_path__ + "img/attack_stormbringer.8a9e584c.png";